import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 0, // Global setting for no retries on all queries
            staleTime: 0, // You might also want to set other global defaults here
            refetchOnWindowFocus: false, // For example, to globally disable refetch on window focus
            refetchOnReconnect: false, // To globally disable refetch on reconnect
        },
        mutations: {
            // You can also set default options for mutations here if needed
            retry: 0, // Although mutations often have different retry needs
        }
    },
});

export default queryClient;
